(function ($) {
    $(document).ready(function() {

        var taxNews = drupalSettings.irbradix.taxNews;

        if (window.location.pathname.search("news")>-1 || window.location.pathname.search("noticias")>-1 || window.location.pathname.search("noticies")>-1){
            var hash = window.location.hash.replace("#","");
            hash = hash.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            //console.log("hash: " + hash);
            var select = document.getElementsByTagName("select")[0];
            //console.log("select: " + select);
            for (var arrayKey in taxNews) {
            var key = arrayKey.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            key = key.replace(/\s+/g, '-').toLowerCase();
            //console.log("key: " + key);
            if (key == hash){
                for (var i = 0; i < select.options.length; i++) {
                var optionValue = select.options[i].getAttribute('value');
                //console.log("optionValue: " + optionValue);
                //console.log("taxNews[arrayKey]: " + taxNews[arrayKey]);
                if (taxNews[arrayKey] == +optionValue){
                    select.options[i].selected = true;
                    //console.log("select.options[i].selected: " + select.options[i].selected);
                    document.getElementById("edit-submit-view-news").click();
                    $( document ).ajaxComplete(function () {
                    if ( $('.select').length == 0) {
                        $(this).customSelect();
                    }
                    });
                }
                }
            }
            };
        };
    });
})(jQuery);
